import { render, staticRenderFns } from "./SearchSentence.vue?vue&type=template&id=fbbe0a8a&lang=pug&"
import script from "./SearchSentence.vue?vue&type=script&lang=js&"
export * from "./SearchSentence.vue?vue&type=script&lang=js&"
import style0 from "./SearchSentence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports